import { FC } from 'react';
import { GetFirmSettingsDocument, useGetFirmSettingsQuery } from '~src/graphql/queries/settings';
import { useAppSelector } from '~src/redux/hooks';
import {
  Typography, Row, Col, Layout, Spin, message, Switch, Space,
} from 'taxaroo-ui';
import { FirmSettingsEntity } from '~src/graphql';
import {
  useCreateFirmSettingMutation,
  useUpdateFirmSettingMutation,
} from '~src/graphql/mutations/settings';
import { ApolloError } from '@apollo/client';
import { useGetPlanAccessLevelQuery } from '~src/graphql/queries/stripeInformation';
import SettingsHeader from '../SettingsHeader';

const { Text, Paragraph, Title } = Typography;

const Monetization: FC = () => {
  const { firmAccountId, accessToken } = useAppSelector((state) => state.session);
  //   const [enableClientBot, setEnableClientBot] = useState<boolean>(false);
  const { data: monetizationSettings, loading: monetizationSettingsLoading } = useGetFirmSettingsQuery({
    variables: { category: 'FIRM_MONETIZATION_SETTINGS' },
    skip: !firmAccountId,
    onError: (error) => {
      message.error(error.message);
    },
  });

  const handleOnError = (error: ApolloError) => {
    message.error(`An error has occurred: ${error.message}.`);
  };

  const { data: planAccessData, loading: loadingPlanType } = useGetPlanAccessLevelQuery({
    skip: !accessToken,
  });
  const currentPlanAccess = planAccessData?.getPlanAccessLevel?.planType;

  const [createFirmSetting, { loading: createFirmSettingLoading }] = useCreateFirmSettingMutation({
    onError: handleOnError,
    refetchQueries: [
      { query: GetFirmSettingsDocument, variables: { category: 'FIRM_MONETIZATION_SETTINGS' } },
    ],
    awaitRefetchQueries: true,
  });
  const [updateFirmSetting, { loading: updateFirmSettingLoading }] = useUpdateFirmSettingMutation({
    onError: handleOnError,
    refetchQueries: [
      { query: GetFirmSettingsDocument, variables: { category: 'FIRM_MONETIZATION_SETTINGS' } },
    ],
    awaitRefetchQueries: true,
  });

  const getIsDisabled = (settingName: string) => {
    console.log(currentPlanAccess);
    switch (settingName) {
      case 'enable-client-audit-assistance':
        return currentPlanAccess === 'FREE';
      default:
        return true;
    }
  };

  const changeSetting = async (setting: FirmSettingsEntity, val: boolean) => {
    try {
      if (setting.id) {
        await updateFirmSetting({
          variables: {
            id: setting.id,
            value: String(val),
          },
        });
      } else {
        await createFirmSetting({
          variables: {
            name: setting.name,
            value: String(val),
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <SettingsHeader
        title="Monetization Settings"
        tooltipTitle="Monetization Settings"
        tooltipContent={(
          <Paragraph>
            <Text>Customize your monetization features</Text>
          </Paragraph>
        )}
      />
      <div style={{ paddingTop: '20px', marginBottom: '125px' }}>
        <Col style={{ width: '100%' }} align="middle">
          {monetizationSettings?.getFirmSettings?.map((setting) => (
            <Row>
              <Space direction="vertical" align="start">
                <Title style={{ margin: 0 }} level={5}>
                  {setting.description}
                </Title>
                <Switch
                  onChange={(val: boolean) => changeSetting(setting, val)}
                  // eslint-disable-next-line
                  checked={setting.value.__typename === "BooleanValue" ? setting.value?.boolValue : false}
                  loading={updateFirmSettingLoading || createFirmSettingLoading}
                  disabled={getIsDisabled(setting.name)}
                />
              </Space>
            </Row>
          ))}
        </Col>

        {monetizationSettingsLoading && (
          <Row align="middle" justify="center">
            <Spin size="large" />
          </Row>
        )}
      </div>
    </Layout>
  );
};

export default Monetization;
